import { css } from 'styled-components';
import { ClockConfigType } from '../config/letters/config.types';

export const BasicComponentsWrapper = css<{
  $size: number;
  $isFullscreen: boolean;
  $configType?: ClockConfigType;
}>`
  height: ${props => props.$size / (props.$configType === 'russian' ? 1.35 : 1.3)}px;
  aspect-ratio: 1;
  padding: 4rem;
  transition:
    scale 0.15s ease-out,
    opacity 0.25s ease-out,
    height 0.15s ease-out,
    width 0.15s ease-out,
    left 0.15s ease-out,
    top 0.15s ease-out;
  transform-origin: left top;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @media screen and (max-width: 1025px) {
    height: ${props => props.$size / 2}px;
  }

  @media screen and (max-width: 750px) {
    height: ${props => props.$size / 1.2}px;
    aspect-ratio: 9 / 16;
    padding: 3rem;
    transform: translate(-50%, -55%);
  }

  @media screen and (max-height: 500px) {
    height: ${props => props.$size - 80}px;
    aspect-ratio: 1;
    padding: 2rem;
  }

  ${props =>
    props.$isFullscreen &&
    css`
      top: 0;
      left: 0;
      transform: none !important;
      width: 100vw !important;
      height: 100svh !important;
      transform-origin: center top;
    `}
`;
